import axios from "../config/axios-chatbot";

export const FlowProtectionRepository = {
    getStatus: (flowUid) => axios.get(`/api/flow-project/${flowUid}/protection`),
    setPassword: ({flowUid, password}) => axios.post(`/api/flow-project/${flowUid}/protection`, {password}),
    updatePassword: ({flowUid, oldPassword, newPassword}) => axios.put(`/api/flow-project/${flowUid}/protection`, {
        oldPassword,
        newPassword
    }),
    authenticate: ({flowUid, password}) => axios.post(`/api/flow-project/${flowUid}/protection/auth`, {password}),
}
